import { useState, useEffect } from "react";
import styled from "styled-components";
import Benefit from "./Benefit";
import { getBenefits } from "../client";
import { FaHandshakeSimple } from "react-icons/fa6";

const BenefitsStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
`;

const Title = styled.h2`
  color: var(--water-color);
`;
const Description = styled.h3`
  color: var(--water-color);
`;
const Text = styled.p`
  font-size: 20px;
  line-height: 1.5;
`;
const BenefitsContainer = styled.div`
  width: 100%;
  margin-top: 50px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 40px;

  @media only screen and (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media only screen and (max-width: 600px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

function Benefits() {
  const [benefitsArray, setBenefitsArray] = useState();

  const callGetBenefits = async () => {
    const res = await getBenefits();
    setBenefitsArray(res[0]);
  };

  useEffect(() => {
    callGetBenefits();
  }, []);

  return (
    <BenefitsStyled>
      <Title>
        Benefits <span></span>
      </Title>
      <Description>Why should you hire me?</Description>
      <Text>{benefitsArray?.desc[0]?.children[0]?.text}</Text>
      <BenefitsContainer>
        {benefitsArray &&
          benefitsArray?.benefitObjects?.map((benefit) => (
            <Benefit
              icon={<FaHandshakeSimple />}
              title={benefit?.title}
              desc={benefit?.body[0]?.children[0]?.text}
              borderColor="primary"
            />
          ))}
      </BenefitsContainer>
    </BenefitsStyled>
  );
}

export default Benefits;
